var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.icon)?_c('div',{staticClass:"flex justify-center items-center",class:_vm.id,domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }